// Module-level store so the Footer's floating WhatsApp button knows which
// service the visitor is currently viewing. ServiceDetail sets this on mount
// and clears it on unmount. Mirrors currentProductStore.

let _service = null;

export const setCurrentService = (service) => { _service = service; };
export const getCurrentService = () => _service;
